import { DragPreviewProps } from 'react-arborist';
import styled from 'styled-components';
import { LauncherElementData, useLauncherElementsStore } from '../../../hooks/stores/launcherElementsStore';
import { useUIStore } from '../../../hooks/stores/uiStore';
import { launcherElementInfo } from '../../../info/launcherElementInfo';

export const ElementTreeDragPreview = ({ offset, mouse, id, dragIds, isDragging }: DragPreviewProps) => {
  if (!isDragging) return null;

  return (
    <Overlay>
      <div style={{ position: 'absolute', left: offset?.x, top: offset?.y }}>
        <PreviewNode id={id} />
      </div>
    </Overlay>
  );
};

const PreviewNode = ({ id }: { id: string | null }) => {
  if (!id) return null;
  const [launcherElementsData] = useLauncherElementsStore<Record<string, LauncherElementData>>();
  const element = launcherElementsData[id];
  const { type, name, props: { commands, text } = {} } = element;
  const commandType = commands?.[0]?.type;
  const [UIData] = useUIStore();

  const amount = UIData.selectedElementIDs.length;

  const iconClassName = launcherElementInfo[type]?.iconClassName;

  return (
    <Container>
      {amount > 1 ? (
        <>
          <Icon>
            <i className=" icon-anytask" />
          </Icon>
          <Text>( {amount} ) Elements</Text>
        </>
      ) : (
        <>
          <Icon>{iconClassName && <i className={iconClassName} />}</Icon>
          <Text>{name || commandType || text}</Text>
        </>
      )}
    </Container>
  );
};

const Overlay = styled.div<{ isDragging?: boolean }>`
  position: fixed;
  left: 0;
  top: 0;
  pointer-events: none;
  z-index: 100;
`;

const Container = styled.div`
  box-sizing: border-box;
  height: 100%;
  margin-left: var(--padding-1);
  margin-right: calc(var(--padding-1) / 2);

  display: flex;
  align-items: center;
  border-radius: var(--radius-2);

  color: var(--main-2);
`;
const Icon = styled.div`
  font-size: 20px;
  opacity: 0.5;
`;

const Text = styled.span`
  max-width: 100px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;

  font-size: 12px;
  font-weight: 400;
`;
